import React, { useState } from 'react';
import { Instagram, Twitter, Youtube, Linkedin } from 'lucide-react';
import { LegalModal, TERMINOS, PRIVACIDAD, REEMBOLSOS } from './LegalModal';
type LegalDoc = typeof TERMINOS | typeof PRIVACIDAD | typeof REEMBOLSOS | null;
export function Footer() {
  const [openDoc, setOpenDoc] = useState<LegalDoc>(null);
  return <>
      <footer className="bg-black border-t border-gold/10 pt-20 pb-10 relative z-10" data-id="element-107">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-108">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8 mb-16" data-id="element-109">
            <div className="md:col-span-1" data-id="element-110">
              <img src="https://cdn.magicpatterns.com/uploads/4XknvFXaqMT9G8np8YGhsH/ChatGPT_Image_May_16,_2026_at_02_14_51_PM.png" alt="Elemental" className="h-20 md:h-24 lg:h-28 w-auto object-contain mb-4 -ml-8 -mt-4" style={{
              filter: 'invert(1)'
            }} data-id="element-111" />
              <p className="text-cream/40 text-sm font-light max-w-xs" data-id="element-112">
                El sistema definitivo de inteligencia artificial para
                profesionales modernos.
              </p>
            </div>

            <div data-id="element-113">
              <h4 className="text-cream text-sm font-medium mb-6 uppercase tracking-widest" data-id="element-114">
                Producto
              </h4>
              <ul className="space-y-4 text-cream/50 text-sm font-light" data-id="element-115">
                <li data-id="element-116">
                  <a href="#inicio" className="hover:text-gold transition-colors" data-id="element-117">
                    Inicio
                  </a>
                </li>
                <li data-id="element-118">
                  <a href="#incluye" className="hover:text-gold transition-colors" data-id="element-119">
                    Qué incluye
                  </a>
                </li>
                <li data-id="element-120">
                  <a href="#bonos" className="hover:text-gold transition-colors" data-id="element-121">
                    Bonos Exclusivos
                  </a>
                </li>
                <li data-id="element-122">
                  <a href="#testimonios" className="hover:text-gold transition-colors" data-id="element-123">
                    Testimonios
                  </a>
                </li>
              </ul>
            </div>

            <div data-id="element-124">
              <h4 className="text-cream text-sm font-medium mb-6 uppercase tracking-widest" data-id="element-125">
                Recursos
              </h4>
              <ul className="space-y-4 text-cream/50 text-sm font-light" data-id="element-126">
                <li data-id="element-127">
                  <a href="#soporte" className="hover:text-gold transition-colors" data-id="element-128">
                    Soporte
                  </a>
                </li>
                <li data-id="element-129">
                  <a href="#faq" className="hover:text-gold transition-colors" data-id="element-130">
                    Preguntas Frecuentes
                  </a>
                </li>
                <li data-id="element-131">
                  <a href="mailto:elementaldealsandshop@gmail.com" className="hover:text-gold transition-colors" data-id="element-132">
                    Contacto
                  </a>
                </li>
              </ul>
            </div>

            <div data-id="element-133">
              <h4 className="text-cream text-sm font-medium mb-6 uppercase tracking-widest" data-id="element-134">
                Legal
              </h4>
              <ul className="space-y-4 text-cream/50 text-sm font-light" data-id="element-135">
                <li data-id="element-136">
                  <button onClick={() => setOpenDoc(TERMINOS)} className="hover:text-gold transition-colors text-left" data-id="element-137">
                    Términos de Servicio
                  </button>
                </li>
                <li data-id="element-138">
                  <button onClick={() => setOpenDoc(PRIVACIDAD)} className="hover:text-gold transition-colors text-left" data-id="element-139">
                    Política de Privacidad
                  </button>
                </li>
                <li data-id="element-140">
                  <button onClick={() => setOpenDoc(REEMBOLSOS)} className="hover:text-gold transition-colors text-left" data-id="element-141">
                    Política de Reembolso
                  </button>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-142">
            <p className="text-cream/30 text-xs" data-id="element-143">
              &copy; {new Date().getFullYear()} Elemental. Todos los derechos
              reservados.
            </p>

            <div className="flex items-center gap-6 text-cream/40" data-id="element-144">
              <a href="#" className="hover:text-gold transition-colors" data-id="element-145">
                <Instagram size={18} data-id="element-146" />
              </a>
              <a href="#" className="hover:text-gold transition-colors" data-id="element-147">
                <Twitter size={18} data-id="element-148" />
              </a>
              <a href="#" className="hover:text-gold transition-colors" data-id="element-149">
                <Youtube size={18} data-id="element-150" />
              </a>
              <a href="#" className="hover:text-gold transition-colors" data-id="element-151">
                <Linkedin size={18} data-id="element-152" />
              </a>
            </div>
          </div>
        </div>
      </footer>

      {/* Legal modals */}
      <LegalModal isOpen={openDoc !== null} onClose={() => setOpenDoc(null)} title={openDoc?.title ?? ''} subtitle={openDoc?.subtitle} sections={openDoc?.sections ?? []} data-id="element-153" />
    </>;
}